import React, { useState, useEffect} from 'react';

import "./index.scss";
import promotionTitle from "../../../assets/img/V7/promotionTitle.png";
import SearchBox from "./components/searchBox";
import LatestContent from "./components/latestContent";
const SchemeV7 = () => {

    return (
        <div className="schemeV7Frame" style={window.innerHeight > 1000 ? {marginTop:'3.5rem'} : {marginTop:'6rem'}}>
            <div className="promotionTitleImg">
                <img src={promotionTitle} alt=""/>
            </div>

            <SearchBox/>

            <LatestContent/>

        </div>
    );
}
export default SchemeV7;
